import {
  DetailedHTMLProps,
  ForwardRefExoticComponent,
  HTMLAttributes,
  ReactNode,
  RefAttributes,
} from 'react'
import BaseAlert, { AlertProps as BaseProps } from 'react-bootstrap/Alert'
import { BsPrefixProps, Omit } from 'react-bootstrap/esm/helpers'

export interface AlertProps extends BaseProps {}

export const Alert = (props: AlertProps): JSX.Element => (
  <BaseAlert {...props} />
)

export const Heading = (
  props: JSX.IntrinsicAttributes &
    Omit<
      Pick<
        DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
        'key' | keyof HTMLAttributes<HTMLDivElement>
      > &
        RefAttributes<HTMLDivElement>,
      BsPrefixProps<
        ForwardRefExoticComponent<
          Pick<
            DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
            'key' | keyof HTMLAttributes<HTMLDivElement>
          > &
            RefAttributes<HTMLDivElement>
        >
      >
    > &
    BsPrefixProps<
      ForwardRefExoticComponent<
        Pick<
          DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
          'key' | keyof HTMLAttributes<HTMLDivElement>
        > &
          RefAttributes<HTMLDivElement>
      >
    > & { children?: ReactNode }
): JSX.Element => <BaseAlert.Heading {...props} />
